import { useState } from "react";
import { Phone, Mail, MapPin, Send } from "lucide-react";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Contact</span>
          <h1 className="text-4xl font-black tracking-tight mt-2">Hai să discutăm</h1>
          <p className="text-slate-500 mt-4 leading-relaxed">Solicită o ofertă, consultanță tehnică sau detalii despre serviciile de instalare. Răspundem în cel mai scurt timp.</p>
          <div className="mt-10 space-y-6">
            <div className="flex items-center gap-4"><div className="w-11 h-11 bg-slate-900 text-white flex items-center justify-center"><Phone className="w-5 h-5" /></div><div><div className="text-xs uppercase tracking-wide text-slate-400">Telefon</div><div className="font-bold" data-testid="contact-info-phone">{t("footer_contact_phone")}</div></div></div>
            <div className="flex items-center gap-4"><div className="w-11 h-11 bg-slate-900 text-white flex items-center justify-center"><Mail className="w-5 h-5" /></div><div><div className="text-xs uppercase tracking-wide text-slate-400">Email</div><div className="font-bold" data-testid="contact-info-email">{t("footer_contact_email")}</div></div></div>
            <div className="flex items-center gap-4"><div className="w-11 h-11 bg-slate-900 text-white flex items-center justify-center"><MapPin className="w-5 h-5" /></div><div><div className="text-xs uppercase tracking-wide text-slate-400">Adresă</div><div className="font-bold" data-testid="contact-info-address">{t("footer_contact_address")}</div></div></div>
          </div>
        </div>
        <form onSubmit={submit} className="border border-slate-200 p-8" data-testid="contact-form">
          <div className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Nume</label>
              <Input required value={form.name} onChange={set("name")} className="rounded-none border-slate-300 h-12 mt-2" data-testid="contact-name" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Email</label>
                <Input required type="email" value={form.email} onChange={set("email")} className="rounded-none border-slate-300 h-12 mt-2" data-testid="contact-email" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Telefon</label>
                <Input value={form.phone} onChange={set("phone")} className="rounded-none border-slate-300 h-12 mt-2" data-testid="contact-phone" />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Mesaj</label>
              <Textarea required rows={5} value={form.message} onChange={set("message")} className="rounded-none border-slate-300 mt-2" data-testid="contact-message" />
            </div>
            <button disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white px-6 py-4 font-bold uppercase tracking-wide text-sm transition-colors" data-testid="contact-submit">
              {loading ? "Se trimite..." : <>Trimite mesajul <Send className="w-4 h-4" /></>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
